// extracted by mini-css-extract-plugin
export default {"footerMaxWidth":"style-module--footerMaxWidth--P-aUN"};